import "./AidesFinancieres.module.css";
import EnTete from "@/reusable_sections/Header";
import AperçuDesAidesFinancières from "./sections/AperçuDesAidesFinancières";
// import CommentAccederAuxAides from "./sections/CommentAccederAuxAides"
import PiedDePage from "@/reusable_sections/Footer";
export default function AidesFinancieresPage() {
  return <div>
      <EnTete />
      <AperçuDesAidesFinancières />
      {/* <CommentAccederAuxAides /> */}
      <PiedDePage />
    </div>;
}